
import { Navigate } from "react-router-dom";
import SellerProfile from "@/pages/seller/SellerProfile";
import SellerMeals from "@/pages/seller/SellerMeals";
import SellerBusiness from "@/pages/seller/SellerBusiness";
import SellerPayment from "@/pages/seller/SellerPayment";
import SellerNotifications from "@/pages/seller/SellerNotifications";
import SellerHelp from "@/pages/seller/SellerHelp";
import SellerInbox from "@/pages/seller/SellerInbox";
import SellerOrders from "@/pages/seller/SellerOrders";
import OrderDetails from "@/pages/seller/OrderDetails";
import BecomeCook from "@/pages/seller/BecomeCook";
import CookVerification from "@/pages/seller/CookVerification";
import CookProfileVerification from "@/pages/seller/CookProfileVerification";
import CookQuizPage from "@/pages/seller/CookQuiz";
import EditMealPage from "@/pages/seller/EditMealPage";
import VerificationComplete from "@/pages/seller/VerificationComplete";
import BusinessProfile from "@/pages/seller/BusinessProfile";
import CookProfile from "@/pages/CookProfile";
import { RouteProps } from "@/types/routes";
import { RouteObject } from "react-router-dom";

export const sellerRoutes = ({ session }: RouteProps): RouteObject[] => [
  {
    path: "/cook/:id",
    element: <CookProfile />
  },
  {
    path: "/seller/become-cook",
    element: session ? <BecomeCook /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/verification/profile",
    element: session ? <CookProfileVerification /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/verification/documents",
    element: session ? <CookVerification /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/verification/quiz",
    element: session ? <CookQuizPage /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/verification/complete",
    element: session ? <VerificationComplete /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/profile",
    element: session ? <SellerProfile /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/meals",
    element: session ? <SellerMeals /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/meals/edit/:id",
    element: session ? <EditMealPage /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/orders",
    element: session ? <SellerOrders /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/orders/:id",
    element: session ? <OrderDetails /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/business",
    element: session ? <SellerBusiness /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/business-profile",
    element: session ? <BusinessProfile /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/payment",
    element: session ? <SellerPayment /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/notifications",
    element: session ? <SellerNotifications /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/help",
    element: session ? <SellerHelp /> : <Navigate to="/auth" />
  },
  {
    path: "/seller/inbox",
    element: session ? <SellerInbox /> : <Navigate to="/auth" />
  }
];
